function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.125 9.69531V16.8759C1.125 17.4975 1.6302 18.0023 2.25 18.0023H7.875V9.69531H1.125Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 4.48357H13.3154C13.5707 4.30898 13.79 4.13545 13.9433 3.98022C14.8511 3.06681 14.8511 1.58 13.9433 0.666582C13.0612 -0.22325 11.5246 -0.221138 10.6436 0.666582C10.1552 1.15655 8.86148 3.15128 9.04043 4.48392H8.95957C9.13746 3.15128 7.84371 1.15655 7.35645 0.666582C6.47437 -0.221138 4.9377 -0.221138 4.05668 0.666582C3.15 1.58 3.15 3.06681 4.05562 3.98022C4.20961 4.1358 4.42898 4.30898 4.68457 4.48357H1.125C0.505195 4.48357 0 4.98938 0 5.60994V8.00347C0 8.31428 0.25207 8.56666 0.5625 8.56666H7.875V5.60994H10.125V8.56666H17.4375C17.7479 8.56666 18 8.31428 18 8.00347V5.60994C18 4.98938 17.4959 4.48357 16.875 4.48357ZM7.80855 4.44626C7.80855 4.44626 7.76145 4.48357 7.60043 4.48357C6.82312 4.48357 5.33918 3.67469 4.85437 3.18613C4.38293 2.71094 4.38293 1.93586 4.85437 1.46067C5.08289 1.23082 5.38523 1.10481 5.70727 1.10481C6.0293 1.10481 6.33059 1.23082 6.55875 1.46067C7.31707 2.22449 8.07082 4.17522 7.80855 4.44661V4.44626ZM10.3982 4.48357C10.2386 4.48357 10.1911 4.44766 10.1911 4.44626C9.92883 4.17487 10.6826 2.22379 11.4409 1.46032C11.8944 1.00203 12.6875 0.999565 13.1453 1.46032C13.6178 1.93551 13.6178 2.71059 13.1453 3.18578C12.6605 3.67469 11.1765 4.48322 10.3982 4.48322V4.48357Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.125 9.69531V18.0023H15.75C16.3709 18.0023 16.875 17.4975 16.875 16.8759V9.69531H10.125Z"
});

function SvgIconBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefit);
export default __webpack_public_path__ + "static/media/icon-benefit.cd3bd04c.svg";
export { ForwardRef as ReactComponent };